export default "__VITE_ASSET__DzoteRLf__"